module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "shortcutbar"
  }, [_c('router-link', {
    staticClass: "shortcutbar-link logo-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/dist/logo_white.png",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "shortcutbar-link",
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("home")])]), _vm._v(" "), _c('router-link', {
    staticClass: "shortcutbar-link",
    attrs: {
      "to": "/elements"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_list")])]), _vm._v(" "), _c('router-link', {
    staticClass: "shortcutbar-link",
    attrs: {
      "to": "/Elementkit/overview"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("widgets")])]), _vm._v(" "), _c('router-link', {
    staticClass: "shortcutbar-link",
    attrs: {
      "to": "/spaces"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("public")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b172778!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/Shortcutbar.vue
// module id = 511
// module chunks = 22